import { render, staticRenderFns } from "./MarginsOrdersTable.vue?vue&type=template&id=570a9dfa&"
import script from "./MarginsOrdersTable.vue?vue&type=script&lang=js&"
export * from "./MarginsOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/MarginsOrdersTable.vue
// module id = null
// module chunks = 